import styled from 'styled-components';

export const StyledHeader = styled.header`
  width: 100%;
  padding: 1rem 2rem;
  position: relative;
`;

export const Heading = styled.h1`
  justify-content: flex-start;
  display: flex;
  align-items: center;
  font-size: 4rem;

  > span {
    font-size: 2rem;
    position: relative;
    top: 6px;
    left: 1px;
  }

  > div {
    margin: 0 8px 0 0;
    display: inline-block;
    position: relative;

    > svg {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
`;

export const TagLine = styled.p`
  margin: 0 0 0 3.9rem;
`;

export const HeadingWrap = styled.hgroup`
  padding: 1rem 0 2rem;
`;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderStyles.js